<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Client Monitor Profile of {{
        config.data.monitorData?.Account?.FirstName }} {{ config.data.monitorData?.Account?.LastName }}</span>
      <span class="text-light-color text-base font-normal">#{{ config.data.monitorData?.Id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button (btnClick)="ref.close()" [iconOnlyButton]="true" icon="icon-x" sizeClass="p-button-sm" severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<app-tabs [initialTabIndex]="0">
  @if (accountInformation) {
  <app-tab tabTitle="Account Information">
    <div class="flex gap-spacing-xl flex-column">
      <div class="info-section">
        <h6 class="text-base">Account Information</h6>
        <app-info-card [data]="accountInformation | infoCard"></app-info-card>
      </div>
    </div>
  </app-tab>
  }
  @if (client) {
  <app-tab tabTitle="Linked Clients">
    <div class="flex gap-spacing-xl flex-column">
      <div class="info-section">
        <h6 class="text-base">Linked Clients</h6>
        <app-info-card [data]="client | infoCard"></app-info-card>
      </div>
    </div>
  </app-tab>
  }
  @if (addresses.length > 0) {
  <app-tab tabTitle="Addresses">
    <div class="flex gap-spacing-xl flex-column">
      <div class="info-section">
        <h6 class="text-base">Addresses</h6>
        <app-basic-table [showIndex]="true" [tableData]="addresses | basicTable"></app-basic-table>
      </div>
    </div>
  </app-tab>
  }
</app-tabs>

<div class="p-dialog-footer pt-spacing-3xl px-0">
  <app-button label="Close" (btnClick)="ref.close()" sizeClass="p-button-md" severity="secondary"></app-button>
</div>